<template lang="pug">
  div
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :hideImportBtn="true"
      :showViewPanel="false"
      :hideAddButton="true"
      :showYear="true"
      :hideSearch="true"
      :yearRange="[-3, 7]"
    )
      div(slot="additionalActions")
        div(v-if="userCanEdit").ml-20
          button(
            @click.stop.prevent="openSetting()"
          ).is-full-width.actions-panel__button {{$translate('Настройки')}}

    e-table(
      :defaultColumnWidth="150"
      :actionColumnWidth="75"
      :items="items"
      :showCheckbox="false"
      :showDeleteButton="false"
      @editItem="editItem"
    )

    router-view
</template>

<script>
  import {calculation} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"
  import permissionMixin from '../../mixins/permission-mixin.js'

  export default {
    mixins: [tableMixin, permissionMixin],
    methods: {
      getEndpoint(route){
        return calculation.locationTariffs(route)
      },
      openSetting() {
        const {route, json} = this.getRoute()
        this.$router.push({name: route.name + '.locationTariffSetting.update', query: {prevRoute: json}})
      }
    }
  }
</script>
